module.exports = __webpack_public_path__ + "static/media/bg.7df2549a.svg";